module.exports = __webpack_public_path__ + "static/media/cancel-green.f6972eb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/cancel-green.svg
// module id = 137
// module chunks = 0